/** Optional persistence must not turn a successful API response into an outage. */
export function createServerSelectionStorage(storage: () => Storage) {
  const memory = new Map<string, string>()
  const pending = new Set<string>()
  return {
    get(key: string): string {
      if (pending.has(key)) return memory.get(key) || ''
      try {
        const value = storage().getItem(key) || ''
        memory.set(key, value)
        return value
      } catch { return memory.get(key) || '' }
    },
    set(key: string, value: string): void {
      memory.set(key, value)
      try {
        if (value) storage().setItem(key, value)
        else storage().removeItem(key)
        pending.delete(key)
      } catch { pending.add(key) }
    },
  }
}

export const serverSelectionStorage = createServerSelectionStorage(() => localStorage)
